const Menu =  [
    { header: 'level : Korsak' },
    {
        path    : '/',
        title   : 'Dashboard',    
        name    : 'dashboard',  
        icon    : 'pie_chart', 
        meta    : {breadcrumb:false}
    },                       
    { title : 'Input By Form', icon:'devices', name : 'hitung', meta:{breadcrumbs:false}},
    { title : 'Input By Excel', icon:'subtitles', name : 'hitung/byexcel'},
    { title : 'Kesalahan', name: 'analisis', icon:'whatshot', meta:{breadcrumbs:false}},    
    {
        title: 'Saksi/Child',
        name : 'saksi',
        icon : 'contacts',
        meta : {breadcrumb:false}
    },
    
    
    //NON MENU
    { group: 'hitung',
      visible: false,
      items:[
        { title : 'Form Suara', name: 'form' },
        { title : 'View Suara', name: 'view' },
      ]
    },
    { group: 'analisis',
      visible: false,
      items:[
        { title : 'Form Suara', name: 'form' },
        { title : 'View Suara', name: 'view' },
      ]
    },    
    { group: 'profile',
      visible: false,
      items:[
        { title : 'Profile', meta:{breadcrumbs:false} },
        { title : 'Update Profile', name: 'form' },        
      ]
    },
    { group: 'saksi',
      visible: false,
      items:[
        { title : 'Saksi/Child', name: 'form' },        
      ]
    },
    
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
